const initialState = {
  projects: [],
  project: {},
  locations: [],
  selectedLocation: null,
  loading: false,
  error: null,
};
const projectReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'FETCH_PROJECT_DETAIL':
      return {
        ...state,
        loading: true,
        project: action.payload,
      };
    case 'FETCH_PROJECT_LOCATIONS':    
      return {
        ...state,
        loading: true,
        locations: action.payload,
      };
    case 'FETCH_LOCATION_DETAIL':
      return {
        ...state,
        loading: true,
        selectedLocation: action.payload,
      };
    default:
      return state;
  }
}
export default projectReducer;